// extracted by mini-css-extract-plugin
export var container = "_gl-0";
export var content = "_gl-3";
export var customerTitle = "_gl-4";
export var empty = "_gl-5";
export var gray = "_gl-6";
export var header = "_gl-7";
export var info = "_gl-8";
export var loading = "_gl-2";
export var loadingCard = "_gl-9";
export var oneLine = "_gl-a";
export var personName = "_gl-e";
export var pillContainer = "_gl-b";
export var selected = "_gl-1";
export var text = "_gl-c";
export var twoLines = "_gl-d";
export var unread = "_gl-f";
export var unreadIndicator = "_gl-g";